<template>
  <div id="networking-add-new-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="16" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.networking.networkingAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.networking.networkingAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" clearable :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="8" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.networking.networkingAddUpdate.numberOfPeople") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.networking.networkingAddUpdate.numberOfPeopleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.peopleCount" clearable @clear="form.peopleCount = null" :class="$inputError('peopleCount', validationErrors)">
                  <el-option :label="2" :value="2"></el-option>
                  <el-option :label="4" :value="4"></el-option>
                  <el-option :label="6" :value="6"></el-option>
                  <el-option :label="8" :value="8"></el-option>
                  <el-option :label="10" :value="10"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("peopleCount", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" key="content" v-if="form">
            <el-col :span="12" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.networking.networkingAddUpdate.cover") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.networking.networkingAddUpdate.coverMsg") }}</span>
                    </div>
                    <i v-if="logoCoverPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="mage-maker drag" :style="{ background: form.cover ? `url(${$imageus + form.cover + '?width=1120&height=500&mode=cover'})` : 'none', 'border-radius': '5px' }">
                  <el-upload :onProgress="logoCoverProgress" :style="{ opacity: !!form.cover ? '0' : '1' }" class="avatar-uploader cover-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=networkingAreaCover&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" drag :on-success="logoCoverSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage("cover", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="12" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.networking.networkingAddUpdate.backgroundImage") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.networking.networkingAddUpdate.backgroundImageMsg") }}</span>
                    </div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="mage-maker drag" :style="{ background: form.backgroundBanner ? `url(${$imageus + form.backgroundBanner + '?width=1120&height=500&mode=cover'})` : 'none', 'border-radius': '5px' }">
                  <el-upload :onProgress="logoProgress" :style="{ opacity: !!form.backgroundBanner ? '0' : '1' }" class="avatar-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=networkingArea&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" drag :on-success="logoSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage("backgroundBanner", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <!-- <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="staffDock = !staffDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.networking.networkingAddUpdate.authorities.authorities") }}</label>
                 
                      <div class="error" style="display:inline-block" v-if="validationErrors.some(x => x.key.includes('managers'))">{{ $t("contentManagement.networking.networkingAddUpdate.oneError") }}</div>
                    </div>
                    <span>{{ $t("contentManagement.networking.networkingAddUpdate.authorities.authoritiesMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="staffDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="staffDock">
                    <el-row :gutter="10" class="mt-3">
                      <el-col :span="24">
                        <div class="add-manager-container">
                          <div class="add-manager-title">
                            <div class="add-m-input">
                              <el-select v-model="lastParticiId" clearable @clear="lastParticiId = null" :placeholder="$t('contentManagement.networking.networkingAddUpdate.authorities.selectAuth')" filterable>
                                <el-option v-for="(item, index) in getParticipantsItems" :key="index" :label="item.firstName + ' ' + item.lastName" :value="item.id"></el-option>
                              </el-select>
                            </div>
                            <div class="add-m-btn">
                              <el-button round size="small" type="primary" @click="addManager">{{ $t("contentManagement.networking.networkingAddUpdate.authorities.add") }}</el-button>
                            </div>
                          </div>

                          <template v-if="form.managers.length > 0">
                            <div class="managers-title custom-grid-table-header">
                              <div></div>
                              <div>{{ $t("contentManagement.networking.networkingAddUpdate.authorities.authorized") }}</div>
                              <div>{{ $t("contentManagement.networking.networkingAddUpdate.authorities.task") }}</div>
                              <div class="text-center">{{ $t("contentManagement.networking.networkingAddUpdate.authorities.view") }}</div>
                              <div></div>
                            </div>

                            <draggable :list="form.managers" tag="div" handle=".el-icon-s-grid" class="list-group-o managers-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                              <div class="item" v-for="(item, index) in form.managers" :key="index" :class="{ passive: !item.isActive }">
                                <div class="table-icon">
                                  <i class="el-icon-s-grid burger"></i>
                                </div>

                                <div class="participant-card-mini">
                                  <div class="participant-card-mini-right">
                                    <div class="participant-card-mini-num">#{{ item.participant.participantNO }}</div>
                                    <div class="participant-card-mini-title">{{ item.participant.firstName + " " + item.participant.lastName }}</div>
                                    <div class="participant-card-mini-container">
                                      <span>
                                        <i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == item.participant.tagID).color }"></i>
                                        <span>{{ $store.state.tags.items.find(x => x.id == item.participant.tagID).title }}</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <el-select v-model="item.type" v-if="getEnums" :class="$inputError('managers[' + index + '].Type', validationErrors)" :remote-method="remoteMethod">
                                    <el-option v-for="(manager, index) in getEnums.find(x => x.title == 'NetworkingAreaManagerType').enums" :label="manager.displayName" :value="manager.key" :key="index"></el-option>
                                  </el-select>
                                </div>
                                <div class="text-center"><el-switch v-model="item.isActive"></el-switch></div>
                                <div style="display:flex; flex-direction:row;gap:.5rem">
                                  <el-tooltip class="" effect="dark" :content="$t('event.table.delete')" placement="top">
                                    <el-popconfirm @confirm="form.managers.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                      <el-button slot="reference" type="danger" icon="fas fa-trash" size="mini" circle></el-button>
                                    </el-popconfirm>
                                  </el-tooltip>
                                </div>
                              </div>
                            </draggable>
                          </template>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row> -->

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.networking.networkingAddUpdate.settings.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.networking.networkingAddUpdate.settings.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.networking.networkingAddUpdate.settings.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.networking.networkingAddUpdate.settings.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.networking.networkingAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("contentManagement.networking.networkingAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.networking.networkingAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo, draggable },
  name: "NetworkingAddUpdate",
  props: ["id"],
  data() {
    return {
      staffDock: false,
      settingsDock: false,
      controlsDock: false,
      form: null,
      loading: false,
      timeout: null,
      lastParticiId: null,
      logoPercent: 0,
      logoCoverPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      dragList: false
    };
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    addManager() {
      if (this.lastParticiId != null) {
        var attende = this.getParticipantsItems.find(x => x.id == this.lastParticiId);
        var payload = {
          id: null,
          participantId: attende.id,
          isActive: true,
          type: null,
          participant: attende
        };
        if (this.form.managers.find(x => x.participantId == attende.id)) {
          this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.alreadyHas"));
        } else {
          this.form.managers.push(payload);
        }
      } else {
        this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.selectAuth"));
      }
      this.lastParticiId = null;
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateNeworking", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getNetworkings");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.backgroundBanner = response.data.item.url;
      }
    },
    logoCoverProgress(event) {
      this.logoCoverPercent = event.percent;
    },
    logoCoverSuccess(response) {
      this.logoCoverPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.cover = response.data.item.url;
      }
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    getParticipantsItems() {
      return this.$store.getters.getParticipantsItems;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    await this.$store.dispatch("getParticipants");
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getNetworking", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          title: null,
          orderNO: 1,
          peopleCount: 4,
          backgroundBanner: null,
          cover: null,
          isActive: false,
          managers: []
        };
        this.loading = false;
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.height-fix {
  height: unset;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}

// .mage-maker {
//   width: 100%;
//   position: relative;
//   border: 1px dashed #ccc;
//   height: 250px;
//   background-size: contain !important;
//   background-position: center center !important;
//   border-radius: 5px;
//   background-repeat: no-repeat !important;
//   .avatar-uploader {
//     opacity: 0;
//     transition: all 1s;
//     &:hover {
//       opacity: 1 !important;
//     }
//     & > .el-upload {
//       background-color: rgba(0, 0, 0, 0.5);
//       width: 100%;
//       height: 250px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }
// }

.managers-title {
  grid-template-columns: 30px 1.5fr 1fr 90px 60px;
  gap: 1rem;
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  .add-manager-title {
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 1rem;
    border-radius: 8px;
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}

.managers-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          color: #292f3b;
          font-weight: 600;
          & > span {
            color: #606266 !important;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 500;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 30px 1.5fr 1fr 90px 60px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      cursor: pointer;
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.networking-rooms-title {
  grid-template-columns: 36px 1fr 200px 52px 40px;
}
.networking-rooms-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }
  .item {
    .img-title {
      display: flex;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .networking-title {
          display: flex;
          flex-direction: column;
          color: #292f3b !important;
          font-weight: 600 !important;
          margin: unset !important;
          div {
            font-weight: 500;
            color: #505763;
          }
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 500;
            color: #505763;
            font-size: 13px;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 36px 1fr 200px 50px 40px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    gap: 0.5rem;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NetworkingAddUpdate.vue